import { Redirect, useLocalSearchParams } from 'expo-router'
import usePayments from '@order/hooks/usePayments'
import PaymentStatus from '@screens/payment/status'

export default function PaymentStatusPage() {
  const { id } = useLocalSearchParams<{ id: string }>()

  const payments = usePayments((s) => s.payments)

  if (!id) {
    return <Redirect href="/checkout" />
  }

  const payment = payments[id]

  if (!payment) {
    return <Redirect href="/checkout" />
  }

  return <PaymentStatus payment={payment} />
}
